module.exports = __webpack_public_path__ + "static/media/survivingForDummiesSY.718f7e3b.jpeg";